<template>
    <div :class="showPageBreak ? 'html2pdf__page-break pagebreak' : 'html2pdf__page-break'"></div>
</template>

<script>
    /**
     * As you can see, it's surely an empty block =))
     */
    export default {
        name: "PrintPageBreakControl",
        props: ['viewSubmissionMode'],

        created() {            
        },

        computed: {
            builderMode() {
                if(this.$parent.readOnly || this.$parent.readOnly === false)
                    return false;
                else
                    return true;                    
            },

            showPageBreak() {
                if(this.builderMode)
                    return true;
                else
                    return false;
            }
        }
    }
</script>

<style scoped>
.pagebreak {
    margin-top: 30px;
    margin-bottom: 30px;
    border-style:dashed; border-width:1px;
    
}
</style>